import { useState } from 'react';
import { SuccessPage } from './SuccessPage';
import { PostConnectSurveyPage } from './PostConnectSurveyPage';

export function DebugSurveyFlowPage() {
  const [step, setStep] = useState<'success' | 'survey'>('success');

  if (step === 'survey') {
    return (
      <PostConnectSurveyPage
        surveyId="fabric-care"
        onBack={() => setStep('success')}
        debugRedirectUrl="/debug/tap-connect/success"
      />
    );
  }

  return (
    <SuccessPage
      isExternalCompletionUser={true}
      showPostConnectSurvey={true}
      onContinue={() => setStep('survey')}
    />
  );
}
